import { AnalyticsContextValue, NotAvailable } from '@ui-common/analytics'
import { getLanguage, getSourceChannel } from '@ui-common/utils'
import { createContext, PropsWithChildren } from 'react'

import { LoanOfferAnalyticsService } from './service'

type AnalyticsContext = AnalyticsContextValue<LoanOfferAnalyticsService>

export const LoanOfferAnalyticsContext = createContext<AnalyticsContext>({
  analyticsService: new LoanOfferAnalyticsService(),
})

export const LoanOfferAnalyticsProvider = ({ children }: PropsWithChildren) => {
  return (
    <LoanOfferAnalyticsContext.Provider
      value={{
        analyticsService: new LoanOfferAnalyticsService({
          flow: NotAvailable,
          product: NotAvailable,
          src: getSourceChannel() ?? NotAvailable,
          ui_lang: getLanguage(),
          version: import.meta.env.VITE_APP_VERSION ?? NotAvailable,
        }),
      }}
    >
      {children}
    </LoanOfferAnalyticsContext.Provider>
  )
}
